function getLocaleFromHtml() {
    /* istanbul ignore else */ return typeof document !== "undefined" ? document.documentElement.getAttribute("lang") : null;
}

export { getLocaleFromHtml };
